import { trimDecimalZero } from '@/helper/number'
import { textByGradeCode, textBySemester, textByTestName } from '@/helper/profile'
import { formatMdWithJpWeekday, formatHHmm } from '@/utils/datetime'
import { relationshipByValue } from '@/utils/relationship'
import { AsYouType, isValidPhoneNumber } from 'libphonenumber-js'

const install = (Vue) => {
  Vue.filter('prettyHHmm', v => {
    if (!v) return ''
    return formatHHmm(v)
  })
  Vue.filter('prettyDate', v => {
    if (!v) return ''
    const dateArray = v.split('T')
    return dateArray[0].replace(/-/g, '/')
  })
  Vue.filter('prettyDateTime', v => {
    if (!v) return ''
    const dateArray = v.split('T')
    const date = dateArray[0].replace(/-/g, '/')
    const time = dateArray[1].slice(0, 5)
    return `${date} ${time}`
  })
  Vue.filter('initial', v => {
    if (!v) return ''
    return v.slice(0, 1)
  }),
  Vue.filter('dateInSlash', v => {
    if (!v) return ''
    return v.replace(/-/g, '/')
  })
  Vue.filter('prettySortNo', v => {
    if (v == undefined) return ''
    const len = parseInt(v).toString(10).length
    if (len >= 3) return `[${v}]`
    return `[${('000' + v).slice(-3)}]`
  })
  Vue.filter('emptyChar', (v, arg) => {
    if (v !== '') return v
    if (!arg) ''
    return arg
  })
  Vue.filter('padStartZero', (v, arg = 3) => {
    return `${v}`.padStart(arg, '0')
  })
  Vue.filter('truncate', (v, arg = 7) => {
    return `${v}`.length <= arg ? v : v.substr(0, arg)
  })
  Vue.filter('prettyMdWithJpWeekDay', (v) => {
    if (!v) return ''
    return formatMdWithJpWeekday(v)
  })
  Vue.filter('circledNumber', (v) => {
    if (!v) return ''
    return String.fromCharCode(9311 + v)
  })
  Vue.filter('relationshipToText', (v) => {
    if (!v) return ''
    return relationshipByValue[v] || v
  })
  Vue.filter('phoneNumber', (v) => {
    if (!v) return ''
    if (isValidPhoneNumber(v, 'JP')) {
      const asYouType = new AsYouType('JP')
      return asYouType.input(v)
    }
    return v
  })
  Vue.filter('gradeCode', (v) => {
    if (!v) return ''
    return textByGradeCode[v] || v
  })
  Vue.filter('semester', (v) => {
    if (!v) return ''
    return textBySemester[v] || v
  })
  Vue.filter('testName', (v) => {
    if (!v) return ''
    return textByTestName[v] || v
  })
  Vue.filter('subjectName', (v) => {
    if (!v) return ''
    // 最初の4文字のみを返す
    return v.slice(0, 4)
  })
  Vue.filter('trimDecimalZero', (v) => {
    if (!v) return ''
    return trimDecimalZero(v)
  })
}

export default {
  install
}